import { render, staticRenderFns } from "./Mapseats.vue?vue&type=template&id=03a430b8"
import script from "./Mapseats.vue?vue&type=script&lang=js"
export * from "./Mapseats.vue?vue&type=script&lang=js"
import style0 from "./Mapseats.vue?vue&type=style&index=0&id=03a430b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports